import React from "react";

const HorizontalButtonGroup: React.FC = ({ children }) => {
  return <div className="c-horizontal-button-group">{children}</div>;
};

export default HorizontalButtonGroup;
